module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "dof-image weex-el weex-image",
    style: ({
      width: _vm._px2rem(_vm.computedStyle.width, 75),
      height: _vm._px2rem(_vm.computedStyle.height, 75)
    }),
    attrs: {
      "src": _vm.iconSrc,
      "aria-hidden": true,
      "data-img-src": _vm.iconSrc,
      "weex-type": "image",
      "data-evt-load": ""
    },
    on: {
      "load": _vm.onLoad
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23f5f2e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f5f2e3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-rich-text/dof-rich-text-icon.vue
// module id = 588
// module chunks = 0 1